import { Reducer } from "redux";
import { StashDeployInfoAction, UnstashDeployInfoAction, StashPayload, STASH_DEPLOY_INFO, UNSTASH_DEPLOY_INFO } from "@/actions/deployStash";


type ActionTypes =
  | StashDeployInfoAction
  | UnstashDeployInfoAction

  
export enum Status {
  Init = 0
}

export type State = StashPayload | null

const initialState = null


export const deployStashReducer: Reducer<State, ActionTypes> = (
  previousState = initialState,
  action
) => {
  switch (action.type) {

    case STASH_DEPLOY_INFO:
      return { ...(action.payload) }
    case UNSTASH_DEPLOY_INFO:
      return null
    default:
      return previousState;
  }
}

export const getStashedDeployInfo = (state:any) => state.od.deployStash;


